var showHelp = {}

showHelp.GetHelpMessage = function (sitename) {
    var aMessage = [];
    aMessage.push({ textbr: "About", textclass: "font-weight-bold" });
    aMessage.push({
        divider: true,
        textbr:
            "Mobile-compatible feedback form for MIT.nano problems.",
    });
    aMessage.push({ textbr: " " });
    aMessage.push({ textbr: "Version", textclass: "font-weight-bold" });
    aMessage.push({ divider: true, textbr: "1.1 - Mar 2025" });
    aMessage.push({ textbr: " " });
    aMessage.push({
        textbr: "How do I use this page?",
        textclass: "font-weight-bold",
    });
    aMessage.push({ divider: true });
    if (sitename == "argh") {
        aMessage.push({
            textbr:
                "The goal of this site is for you to tell us about problems in the lab. You can enter a description of the issue, take or attach a photo, and send it to us.",
        });
    } else {
        aMessage.push({
            textbr:
                "The goal of this site is for MIT.nano PIs to tell us about problems, ideas, and suggestions. You can enter a description of the issue, take or attach a photo, and send it to us.",
        });
    }
    aMessage.push({ textbr: " " });
    aMessage.push({
        textbr: "Who gets the submissions?",
        textclass: "font-weight-bold",
    });
    aMessage.push({ divider: true });
    if (sitename == "argh") {
    aMessage.push({
        textbr:
            "Submissions are emailed to the MIT.nano Associate Directors. Details will then be sent to the relevant staff, where applicable.",
    });
} else {
    aMessage.push({
        textbr:
            "Submissions are emailed to the MIT.nano Directors, and follow-up discussions may take place at the Leadership Council.",
    });
}
    aMessage.push({ textbr: " " });
    aMessage.push({
        textbr: "Is it Anonymous?",
        textclass: "font-weight-bold",
    });
    aMessage.push({ divider: true });
    aMessage.push({
        textbr:
            "Yes. Even if you enter your name here, when forwarding for resolution, we will remove any names.",
    });
    aMessage.push({ textbr: " " });
    aMessage.push({
        textbr: "Privacy",
        textclass: "font-weight-bold",
    });
    aMessage.push({ divider: true });
    aMessage.push({
        textbr:
            "Please do not submit photos of other people. We log the submitter's IP address data to discourage spam or other misuse.",
    });
    return aMessage
}

showHelp.GetErrorMessage = function () {
    var aMessage = [];
    aMessage.push({ textbr: "Upload Error", textclass: "font-weight-bold" });
    aMessage.push({
        divider: true,
        textbr:
            "There was an error while trying to upload your file.  If it persists, please email us about this (maybe the server crashed or something else is not right)",
    });
    return aMessage
}

module.exports = showHelp